module.exports = __webpack_public_path__ + "img/stock3.16a2d97b.png";